import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, isEqual, map, capitalize } from "lodash";
import { validateRequiredFields } from "../../utils/validation.util";
import { normalizeAmount, formatData } from "../../utils/transformer.util";
import {
  Button,
  Select,
  Pagination,
  SearchSelect,
  Input,
} from "../../components/base/index";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { ProgressBar } from "react-bootstrap";

const MySwal = withReactContent(Swal);
const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};
export default class TambahDataMapel extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._setForm = this._setForm.bind(this);
    this._getParamPerwakilan = this._getParamPerwakilan.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);

    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          list: [],
          organizations_id: organizations_id,
          units_id: school_unit.id
        },
        error: {},
      },
      param: {},
      listOld:[],
    };
  }

  componentDidMount() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data, units_value } = state;
    const { school_unit, organizations_id } = user;
    // let savedForm = JSON.parse(window.localStorage.getItem('strukturForm')) || '';
    // let savedFilters = JSON.parse(window.localStorage.getItem('strukturFilters')) || filters;
    this._getSchoolUnitsOptions();

    // if (isEdit && data.length !== 0) {

    //   this.setState({units_value:units_value})
    //   this._setForm(units_value);
    // }
    this._onSearchContent();
    this._getParamPerwakilan();

  }

  // componentDidUpdate(prevProps, prevState) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   if (prevState.form.value !== this.state.form.value) {
  //     // console.log(this.state.form.value.list)
  //     // this.setState({ listOld: this.state.form.value.list })
  //     // form.value baru selesai di-update, kamu bisa pakai di sini
  //     // this._onSearchContent();
  //   }
  //   // if (!isEqual(prevProps, this.props)) {
  //   //   this._onSearchContent();
  //   // }
  // }

  async _getParamPerwakilan(filters = {}) {
    const { getParamPerwakilan, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getParamPerwakilan(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        perwakilan_prm: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }
 

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === "user_groups_id") {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          username: "",
        },
      }));
    }
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        if (name === 'perwakilan_id'){
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
          this._getSchoolUnitsOptions({perwakilan_id: value.value})
          // if(value.value == 'all'){
          // this._onSearchContent();
          // }
        }
        if (name === "units_id") {
          const param = this.state.param.units;
          const levels_units = param.find((i) => i.value == value.value)
            ? param.find((i) => i.value == value.value).attributes.levels_id
            : "";

          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_id: levels_units,
                units_id: value,
              },
            },
          }));
        }
        this._onSearchContent();
      }
      
    );
  }

  async _onSearchContent(params = {}) {
    const { filters, param } = this.state;
    let savedFilters = JSON.parse(window.localStorage.getItem("param")) || "";
    const prm_usergroups = savedFilters.userGroups;
    this.setState({
      content: initialContent,
    },async () => {
      try {
        const { handleListMapelActive, user, location } = this.props;
        const { school_unit, organizations_id } = user;
        const { state = {} } = location;
        const { isEdit = false, data, units_value } = state;
        const result = await handleListMapelActive({
          organizations_id: organizations_id,
          units_id: school_unit.id,
          filters,
        });
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              list: result,
            },
          },
        }), () => {
          if (isEdit && data.length !== 0) {

            this.setState({units_value:units_value})
            this._setForm(units_value);
          }
          console.log("LIST DI STATE:", this.state.form.value.list);
            // Setelah list di-set, panggil _setForm
            // this._setForm(units_value);
          });
    
      } catch (err) {
        // if (this.isMount) {
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              list: [],
            },
          },
        }));
      }
      // }
    });
  }


  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { list, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(list));
    newList.forEach((item) => {
      item.is_blocked = isBlocked;
    });

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          list: newList,
        },
      },
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;

    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName] || [];
          newListError = prevState.form.error[fieldName] || [];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        // if (name === 'classes_id') {
        //   this._getParamOptionsAcademics( 'classrooms', {classes_id: value, organizations_id });
        // }
        if (name === "is_blocked" && !inputArray) {
          this._setIsBlocked(value);
        }
        if (name === "levels_id") {
          this._getClassesOptions({ filters: { levels_id: [value] } });
        }
        if (name === "classes_id") {
          const param = this.state.param.classes_prm;
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                // graduate: param.find(i => i.value == value).attributes.graduate,
              },
            },
          }));
        }
      }
    );
  }
  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td style={{width:"40px"}}>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/tambah-master-mapel", {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  async onClickSubmit() {
    const { history, handleSaveMapelUnits, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    await handleSaveMapelUnits(value);
    history.push("/dashboard/pengaturan/data-mapel-unit");
    // history.go(0);
  }

  async onClickUpdate() {
    const { history, handleUpdatetMasterMapel, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    await handleUpdatetMasterMapel(value);
    history.push("/dashboard/pengaturan/tambah-master-mapel");
    history.go(0);
  }

  async onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/tambah-master-mapel", {
      data: val,
      isEdit: true,
    });
    history.go(0);
  }

   async _setForm(units_value) {
      const { handleGetMapelUnits, user, location } = this.props;
      const { param, form } = this.state;
      const { state = {} } = location;
      const { isEdit = false, data } = state;

      const { value } = form;
      const { list } = value;
      const { organizations_id } = user;
      const prm_units = param.units ? param.units : '';
      // ingin memanggil list disini
      try {
        const payload = await handleGetMapelUnits({
          units_value
        });

      const combined = [...list, ...payload.mapel];
      const uniqueMap = new Map();

      combined.forEach(item => {
        const existing = uniqueMap.get(item.id);
      
        if (!existing) {
          // Belum ada, simpan langsung
          uniqueMap.set(item.id, item);
        } else {
          // Sudah ada, cek prioritas checked:true
          if (item.checkbox && !existing.checkbox) {
            uniqueMap.set(item.id, item);
          }
          // Kalau existing sudah checked atau item baru tidak checked, abaikan
        }
      });
      
      const result = Array.from(uniqueMap.values());
      
      console.log(result);
      let listNew = result;
        const { classes, levels_id, classes_id } = payload;
        this.setState({
          form: {
            value: {
              // id: payload.id,
              units_id: payload.units_value,
              mapel: payload.mapel,
              list: result,
            },
            error: {
              list: [],
            },
          },
        });
      } catch (err) {
        // err action
      }
    }

    



  render() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { form, filters, param } = this.state;
    const { state = {} } = location;
    const { isEdit = false, data, units_value } = state;
    const { list } = form.value;
    const prm_usergroups = param.userGroups;
    const prm_perwakilan= param.perwakilan_prm ? param.perwakilan_prm : '';
    const prm_units = param.units ? param.units : '';
    const All = [{value: 'all', label: "Semua Perwakilan"}]
    const AllUnit = [{value: 'all', label: "Semua Unit", attributes: {}}]
    const perwakilan_all = [...All, ...prm_perwakilan]
    // const units_all = [...AllUnit, ...prm_units]

    // console.log(list)
    const mapel = form.value.mapel?form.value.mapel:'';
 
    //   const listMapel = form.value.list?form.value.list:'';

    //   const combined = [...listMapel, ...mapel];
    //   const uniqueMap = new Map();
    //   combined.forEach(item => {
    //     const existing = uniqueMap.get(item.id);
      
    //     if (!existing) {
    //       // Belum ada, langsung tambahkan
    //       uniqueMap.set(item.id, item);
    //     } else {
    //       // Sudah ada, cek apakah yang baru checkbox:true
    //       if (item.checkbox && !existing.checkbox) {
    //         uniqueMap.set(item.id, item); // Ganti dengan yang checkbox:true
    //       }
    //       // Kalau dua-duanya checkbox true atau dua-duanya tidak, biarkan yang pertama
    //     }
    //   });
      
    //   // Ubah ke array
    //   const result = Array.from(uniqueMap.values());
      
    //   let listNew = result;
    // }
    // console.log(listNew)
    // else {
      // form.value.list = mapel?result:form.value.list;
      
    // }
    const prm_block = [
      { value: 0, label: "Open All" },
      { value: 1, label: "Block All" },
    ];

    const prm_is_block = [
      { value: 0, label: "Open" },
      { value: 1, label: "Block" },
    ];

    const dataGet= data?data:'';
    const units = prm_units?prm_units.find((i) => i.value == units_value):'';
    console.log(units)

    form.value.units_id = units_value?units:form.value.units_id
     
    form.value.units_value = form.value.units_id?form.value.units_id.value:''
    return (
          <div className="add-budget">
            <div className="budget__title">
              <h1>Tambah Data Mapel Unit </h1>
              <hr></hr>
            </div>
            <form onClickSubmit={this.onClickSubmit}>
              <div className="kode-matpel__custom-form">
                  <div className="absensi-rekap__custom-form-row">
                  {/* <div className="absensi-rekap__custom-form-column__field">
                  <SearchSelect
                      noMargin
                      async={false}
                      name="units_id"
                      list={prm_units}
                      inputArray
                      onClick={this._onChangeFilter}
                      placeholder="Pilih Unit"
                      value={form.value.units_id}
                      rightIcon="icon-search"
                      label="Pilih Unit"
                    />
                  </div> */}
                </div>
              </div>
           
            </form>
            <div className="fund-request__content">
              <table className="table" style={{width:'100%'}}>
                <thead>
                  <tr>
                  <th style ={{width:"5%"}}>No</th>
                  <th style ={{width:"10%"}}>Pilihan</th>
                  <th style ={{width:"20%"}}>Kode Mata Pelajaran</th>
                  <th style ={{width:"85%"}}>Nama Mata Pelajaran</th>
                  {/* <th style ={{width:"100px"}}>Nama Mata Pelajaran</th> */}
                  {/* <th style ={{width:"40px"}}></th> */}
                  </tr>
                </thead>
                <tbody>
                  {map(list, (data, idx) => (
                    <tr key={`budget_row_${idx}`}>
                      <td style={{textAlign:"center"}}>{idx+1}</td>
                       <td key={`table_${idx}`}>
                        <div style={{textAlign:'center', marginLeft:'35%'}}>
                        <Input
                          type="checkbox"
                          name="checkbox"
                          data-input-array={true}
                          data-array-position={idx}
                          data-field-name="list"
                          textAlign="center"
                          onChange={this._onFormChange}
                          // checked={list.checkbox}
                          checked={data.checkbox == true ? true : false}
                          value={data.checkbox ? data.checkbox : false}
                        />{" "}
                        </div>
                      </td>
                      <td style={{textAlign:"center"}}>{data.mapel_code}</td>
                      <td>{data.mapel_name}</td>
                      {/* {this._renderButtons(data)} */}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="student-list__header">
                <div className="student-list__button">
                    <Button
                      type="button"
                      title="Simpan"
                      onClick={this.onClickSubmit}
                    />
                </div>
              </div>
            </div>
          </div>
        );
  }
}
TambahDataMapel.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
TambahDataMapel.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
